<template>
  <div
    class="pb-audio-player row no-gutters"
  >
    <div class="episode-logo col-auto p-0">
      <a title="Episode link on episode" :target="logoUrl?'_blank':'_self'" :href="logoUrl || 'javascript:void();'">
        <img :src="episode.logo" alt="Episode logo" />
      </a>
    </div>
    <div class="main col min-w-0 p-0">
      <div class="row no-gutters top-title-logo">
        <div class="col min-w-0">
          <h3 class="channel-name">
            <a :title="'Podcast title:' + setting.podcastTitle" :target="setting.podcastLink?'_blank':'_self'" :href="setting.podcastLink || 'javascript:void();'">{{
              setting.podcastTitle
            }}</a>
          </h3>
        </div>
        <div v-if="setting.pbad" class="col-auto pb-brand-small-logo pr-2">
          <a
            class="logo"
            target="_blank"
            href="http://www.podbean.com?utm_campaign=pb_web_audio_player&utm_medium=logo&utm_source=pb_web_player"
            title="Podbean"
            >
            <icon-podbean-logo></icon-podbean-logo>
          </a>
        </div>
      </div>
      <div class="row no-gutters pd-episode-name">
        <div class="col min-w-0">
          <h2 class="episode-name">
            <a :title="'Episode title: ' + episode.title" :target="logoUrl?'_blank':'_self'" :href="logoUrl || 'javascript:void();'">{{
              episode.title
            }}</a>
          </h2>
        </div>
        <div class="col-auto pb-actions pr-2">
          <a
            class="info"
            v-if="info"
            href="javascript:;"
            @click="setNonAppDownloadDialogOpen(); isShowInfoDialog = true"
            title="Info"
          >
            <icon-info></icon-info>
          </a>
           <a
            class="downloadLink"
            v-if="podcastApps.length>0"
            href="javascript:;"
            @click="setNonAppDownloadDialogOpen(); isShowPodcastAppsDialog = true"
            title="Podcast Apps"
          >
             <icon-rss/>
          </a>
          <a
            target="_blank"
            class="downloadLink"
            v-if="download && episode.downloadLink"
            :href="episode.downloadLink"
            title="Download"
          >
            <icon-download />
          </a>
          <a
              class="share"
            v-if="share && episode.shareLink"
            href="javascript:;"
            @click="setNonAppDownloadDialogOpen(); isShowShareDialog = true"
            title="Share"
          >
             <icon-share></icon-share>
          </a>
          <div class="chapters" v-if="chapters.length>0">
            <a href="javascript:;" @click="setNonAppDownloadDialogOpen(); isShowChaptersDialog = true" title="Chapter">
             <icon-list-chapers></icon-list-chapers>
            </a>
          </div>
        </div>
      </div>

      <div class="pb-internal-player">
        <pb-player
          ref="pbPlayer"
          :options="videoOptions"
          :type="episode.type"
          :startAt="startAt"
          :episode="episode"
          @pause="pause"
          @play="play"
          @ready="ready"
          :crossorigin="episode.crossorigin"
        ></pb-player>
        <player-toolbar @seekBackward="seekBackward" @seekForward="seekForward"></player-toolbar>
        <player-loading></player-loading>
      </div>
      <canvas v-show="episode.enableWave" id="wave-canvas" ref="canvas"></canvas>

      <app-download class="text-left" v-show="showAppDownloadStatus === 1"></app-download>
     <share-dialog v-if="share && episode.shareLink" @hide="isShowShareDialog=false" v-show="isShowShareDialog"></share-dialog>
     <info-dialog v-if="info" @hide="isShowInfoDialog=false" v-show="isShowInfoDialog"></info-dialog>
     <podcast-apps-dialog @hide="isShowPodcastAppsDialog=false"  v-show="isShowPodcastAppsDialog"></podcast-apps-dialog>
    <chapters-list-dialog @seek-to-chapter-time="chapterGoTo" @hide="isShowChaptersDialog=false" v-show="isShowChaptersDialog"></chapters-list-dialog>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import PbPlayer from "@/components/PbPlayer";
import AppDownload from "@/components/AppDownload";
import ShareDialog from "@/components/ShareDialog";
import InfoDialog from "@/components/InfoDialog";
import PlayerToolbar from "./PlayerToolbar";
import IconDownload from "@/components/IconDownload";
import IconShare from "./icons/IconShare";
import IconInfo from "./icons/IconInfo";
import IconPodbeanLogo from "./icons/IconPodbeanLogo";
import PlayerLoading from "./PlayerLoading";
import { showWave } from '@/common/utils';
import IconRss from "./icons/IconRss";
import PodcastAppsDialog from "./PodcastAppsDialog";
import ChaptersListDialog from '@/components/ChaptersListDialog.vue';
import IconListChapers from "../../live-player/src/components/icons/IconListChapers";
import {MUTATION_UPDATE} from "@/store/mutations";
export default {
  name: "AudioPlayer",
  components: {
    IconListChapers,
    ChaptersListDialog,
    PodcastAppsDialog,
    IconRss,
      PlayerLoading,
      IconPodbeanLogo, IconShare, IconInfo, IconDownload, PlayerToolbar, ShareDialog, InfoDialog, AppDownload, PbPlayer},
  computed: {
    ...mapState([
      "setting",
      "startAt",
      "download",
      "share",
      "info",
      "logoLink",
      "showAppDownloadStatus",
      "podcastApps",
      "chapters"
    ]),
    ...mapGetters(["episode"]),
    logoUrl(){
      if(this.logoLink == "episode_page"){
        return this.episode.link;
      }else if(this.logoLink == "podcast_page"){
        return this.setting.podcastLink;
      }else{
        return "";
      }
    },
    videoOptions() {
      return {
        language: "en",
        autoplay: false,
        controls: true,
        // textTrackSettings:true,
        controlBar: {
          fullscreenToggle: false,
          durationDisplay: false,
          mouseTimeDisplay: false,
          children: [
            "playToggle",
            "currentTimeDisplay",
            "progressControl",
            "remainingTimeDisplay",
            // "currentTimeDisplay",
            // "muteToggle",
            // "volumeControl",
            // "playbackRateMenuButton"
          ]
        },
        // chaptersButton: true,
        bigPlayButton: false,
        loadingSpinner: false,
        sources: [
          {
            src: this.episode.resource,
            type: this.episode.resourceMimetype
          }
        ],
        // tracks:[
        //   {
        //     src:"./webvtt_example.vtt",
        //     kind:"captions",
        //     srclang:"en",
        //     label:"English",
        //     default:true,
        //   },
        //   {
        //     src:"./webvtt_example2.vtt",
        //     kind:"captions",
        //     srclang:"en",
        //     label:"ZHHH",
        //   },
        // ]
      };
    }
  },
  data() {
    return {
      enableDraw: false,
      replayTimer: null,
      isShowShareDialog: false,
      isShowInfoDialog: false,
      isShowPodcastAppsDialog: false,
      isShowChaptersDialog: false,
    };
  },
  watch: {
    skin() {
      // this.draw();
    },
    btnSkin() {
      // this.draw();
    },
  },
  methods: {
    chapterGoTo(seconds){
      this.isShowChaptersDialog = false;
      this.$refs.pbPlayer.setCurrentTime(seconds);
    },
    ready() {
      if (this.episode.enableWave){
        showWave();
      }
    },
    pause() {
    },
    play() {
    },
    seekBackward(){
      this.$refs.pbPlayer.addCurrentTime(- 15);
    },
    seekForward(){
      this.$refs.pbPlayer.addCurrentTime(+ 15);
    },
    setNonAppDownloadDialogOpen() {
      this.$store.commit(MUTATION_UPDATE, ["isNonAppDownloadDialogOpen", true]);
    },
  }
};
</script>

<style lang="scss">
.pb-audio-player {
  border: 1px solid #dedede;
  height: 150px;
  max-height: 150px;
  border-radius: 5px;
  flex-shrink: 0;
  transition: all .2s;
  position: relative;
  width: 100%;
  .info-dialog{
    p,.description{
      font-size: 12px;
    }
  }
  .episode-logo{
    a{
      width: 148px;
      height: 148px;
      min-width: 148px;
      display: block;
      img {
        width: 148px;
        height: 148px;
        min-width: 148px;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
  }

  .main {
    height: 100%;
    display: flex;
    flex-direction: column;
    .top-title-logo{
      padding-top: 3px;
      flex-shrink: 0;
      flex-grow: 0;
      max-height: 26px;
    }
    .pd-episode-name{
      flex-shrink: 0;
      flex-grow: 0;
    }
    h2.episode-name{
      font-size: 16px;
      padding-top: 2px;
    }
    h3.channel-name{
      font-size: 12px;
      font-weight: normal;
      padding-top: 5px;
    }
    h3.channel-name,h2.episode-name {
      padding-left: 10px;
      padding-right: 10px;
      margin: 0;
    }
    .pb-actions{
      display: flex;
      a{
        padding: 2px 3px;
        display: inline-block;
        line-height: 1;
        position: relative;
        top: -1px;
        &.downloadLink{
          top: -2px;
        }
        svg{
          width: 17px;
          height: 17px;
        }
        .bi-info-circle{
          width: 16px;
          height: 16px;
        }
        .bi-share-fill{
          width: 13px;
          height: 13px;
          margin-right: 1px;
        }
      }
      .chapters{
        position: relative;
        svg{
          width: 15px;
          height: 15px;
          margin-top: -2px;
        }
        &:hover{
          .chapters-dropdown-menu{
            display: block;
          }
        }
        .chapters-dropdown-menu{
          display: none;
          list-style: none;
          position: absolute;
          top: 22px;
          right: 0;
          color: #000;
          background: #fff;
          width: 150px;
          border-radius: 12px;
          z-index: 101;
          padding: 15px 20px;
          box-shadow: 0 5px 10px #00000040;
        }
      }
    }

    .pb-brand-small-logo {
      padding-right: 10px !important;
     .icon-podbean-logo{
        width: 40px;
        color: #a1a1a1;
      }
    }

    .video-js {
      width: 100%;
      height: 40px;
     background-color: transparent;

      .vjs-control-bar {
        display: flex;
        height: 44px;
        background-color: transparent !important;
      }
    }
  }

  /* 整个播放条 */
  .pb-internal-player{
    position: relative;
    margin-top: 9px;
    flex-shrink: 1;
    flex-grow: 1;
  }
  .video-js{
     .vjs-control-bar{
       padding-left: 10px;
      .vjs-button{
        width: 44px;
        height: 44px;
        border-radius: 25px;
        transition: all 0.2s;
        text-align: center;
        line-height: 44px;
        position: relative;
        overflow: hidden;
        .vjs-icon-placeholder{
          color: #ffffff;
          font-size: 18px;
          display: block;
          position: absolute;
          left: 0;
          right: 0;
          top: -3px;
          bottom: 0;
          margin: auto;
          &:before{
            //line-height: unset;
            font-size: 31px;
          }
        }
        &:hover{
          opacity: 0.8;
        }
      }
      /* 播放开始默认时间样式 */
      .vjs-time-control{
        font-family: inherit;
        display: block !important;
        position: absolute;
        top: 7px;
        height: 16px;
        line-height: 16px;
        span{
          color: #aaaaaa;
        }
      }
      .vjs-current-time{
        left: 51px;
      }
      .vjs-remaining-time{
        right: 0;
      }
      /* 播放进度条样式 */
      .vjs-progress-control{
        margin-top: 8px;
        .vjs-progress-holder{
          font-size: 1.22em;
          .vjs-slider-bar{
            padding-left: 4px;
            &:before{
              //right: -0.8em;
              //top: -4px;
            }
          }
        }
      }
    }
  }
  canvas {
    width: 100%;
    height: 34px;
    margin-top: 11px;
  }
}
@media (max-width: 425px) {
  .pb-audio-player{
    .episode-logo{
      a{
        width: 92px;
        height: 92px;
        min-width: 92px;
        display: block;
        margin-top: 9px;
        margin-left: 9px;
        img {
          width: 92px;
          height: 92px;
          min-width: 92px;
          border-radius: 6px !important;
        }
      }
    }
    .main{
      position: unset;
    }
    #wave-canvas{
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin-top: 8px;
      height: 40px;
    }


  }
}
</style>
